import { api } from "../../lib/api";
export const startCharger = async ({ assetId, connectorId, projectId, tagId }) => {
    const body = {
        connectorId: String(connectorId),
        ...(tagId ? { tagId } : {})
    };
    const { data } = await api.post(`/projects/${projectId}/chargers/${assetId}/transactions/start`, body);
    return data;
};
export const stopCharger = async ({ assetId, projectId, transactionId }) => {
    const { data } = await api.post(`/projects/${projectId}/chargers/${assetId}/transactions/stop`, undefined, { params: { transactionId } });
    return data;
};
export const rebootCharger = async ({ assetId, projectId, resetType = "HARD" }) => {
    const { data } = await api.post(`/projects/${projectId}/chargers/${assetId}/reboot`, undefined, { params: { resetType } });
    return data;
};
